import React from "react";
import {
    TableContentCustomerAccount
} from '../../../Common/Table/tableContent';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

export default class ComponentToPrint extends React.Component {
    
    render() {
       
       
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalActive = this.props.totalActive;
        const totalInActive = this.props.totalInActive;
        const finalTotal = this.props.finalTotal;

        return (
            <div>
                <h3><center><u>Active Supplier Count Report</u></center></h3>
                <div  className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.route === undefined ? "All Collection Points" : searchData.route}</div>
                    <div className="col"><b>Date: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="table-responsive row-top-gap">

                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Route Name</TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Active</TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>InActive</TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell component="th" scope="row" align="left"> {row[0].collectionPointName}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.active}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.inActive}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.total}</TableCell>

                                    </TableRow>

                                )
                                )}

                            </TableBody>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalActive}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalInActive}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {finalTotal}</TableCell>
                                </TableRow>

                            </TableHead>

                        </Table>
                    </TableContainer>

                </div>
            </div>
        );
    }
}